import React, { Component } from "react";
import axios from "axios";
import _ from "lodash";
import { Link } from "react-router-dom";
import TestimonialBlock from "./TestimonialBlock";
import casestudy from "../assets/casestudy.svg";
import pattern from "../assets/pattern.svg";
class Related extends Component {
  constructor() {
    super();
    this.state = {
      data: null
    };
  }
  componentDidMount() {
    const SITE_URL = "https://oncourse.dev-ggmm.com";

    axios.get(SITE_URL + "/wp-json/wp/v2/testimonials").then(res => {
      this.setState(
        {
          data: res.data
        },
        () => window.scrollTo(0, 0)
      );
    });
  }

  render() {
    const { data } = this.state;
    if (data) {
      return (
        <div className="related-box">
          <div
            className="left"
            style={{ backgroundImage: "url(" + pattern + ")" }}>
            <div>
              <img src={casestudy} alt="More Case Studies" />
              <Link to="/applications" className="btn white">
                View Applications
              </Link>
            </div>
          </div>
          <div className="right">
            {_.map(data, (block, i) => {
              if (i <= 1) {
                return <TestimonialBlock key={i} data={block} />;
              }
            })}
          </div>
        </div>
      );
    } else return false;
  }
}

export default Related;



// WEBPACK FOOTER //
// ./src/components/Related.js